import React, { Component } from 'react';
import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';
import { store } from "../../../testStore";

import { setRoleAccess } from "../../../testActions";
/* React Router */
import { withRouter } from 'react-router-dom'

/* Result */
import Result from 'iotera-base/result'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../../redux/ducks'
import { actions as notificationActions } from '../../../redux/ducks/notification'

/* Routes */
import { domainIsTenant as dit, S } from '../../../routes/routes'

/* Object Json */
import { safeGetWithType } from 'iotera-base/json';
import { isEmpty } from 'iotera-base/object'

import { IoteraForm } from '../../../lib/components/form';
import { SubViewHeader } from '../../../lib/components/subHeader';

import DropdownTreeSelect from 'react-dropdown-tree-select';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { InlineTooltip } from '../../../lib/components/tooltips';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../../lib/components/callbackGlobal';

const ADD = "ADD";
const WKEY = "ROLE_ADD";
const wBoundActions = buildWBoundActions(WKEY);

function schema() {
  return {
  }
};

function uiSchema() {
  return {
  }
};

class RoleAdd extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: [],
      formData: {},
      values: '',
      isSubmit: false,
      loading: false,
      descendant: false,
      selectedNodes: [],
      navs: [],
      navsObj: {}
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleDesc = this.handleDesc.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        wparam: { ...domainIsTenant, path: "/service/web/application/nav/list/detail" },
        wcallback: {
          started: function (id) {
            // TODO Loading
          },
          finished: function (id, result) {
            if (result.code === Result.HTTP.OK) {
              let navs = safeGetWithType(result, ['body', 'navs'], []);
              let navsObj = safeGetWithType(result, ['body', 'navs_root_obj'], {})
              _this.setState({ navs, navsObj })
            }
            // TODO Loading

          }
        },
        wreducer: {
          enable: false
        }
      }
    );
    _props.wSetConfig({
      single_config: {
        [ADD]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/application/account/role/add"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _props.history.push('.' + S + '_role_list_');
                  _this.setState({
                    loading: false
                  })
                  _props.showSingleNotification({ message: 'Tambah Role Sukses', level: 'success' });
                  return;
                }
              }
              _this.setState({
                loading: false
              })
              _props.showSingleNotification({ message: 'Tambah Role Gagal', position: 'tr', level: 'error' });
            }
          },
          wreducer: {
            enable: false
          }
        }
      }
    });
  }

  goTo(link) {
    this.props.history.push(link)
  }

  componentWillUnmount() {
    const _props = this.props
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  handleSubmit(event) {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    let selectedNodes = safeGetWithType(_this, ['access', 'state', 'tags'], []);
    let descendant = safeGetWithType(_state, ['descendant'], false);
    let navsObj = safeGetWithType(_state, ['navsObj'], {});
    // if (selectedNodes.length === 0) {
    //   _props.showSingleNotification({ message: 'Harus memiliki setidaknya satu akses dashboard', level: 'error' });
    //   return;
    // }
    let role =
    {
      navs: selectedNodes,
      navsObj,
      descendant
    }
    let action = setRoleAccess(role);
    store.dispatch(action)
    _props.history.push('.' + S + '_role_add_sort_')
  }

  onChange = (currentNode, selectedNodes) => {
  };

  handleDesc = () => event => {
    const _this = this;
    const _state = _this.state
    let formData = safeGetWithType(_this, ['form', 'state', 'formData'], {});
    _this.setState({ descendant: !_state.descendant, formData, selectedNodes: [] })
  }

  goBack() {
    this.props.history.push('.' + S + '_role_add_info_')
  };

  render() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const { loading } = _state;
    let storeValue = store.getState();
    let dataToShow = storeValue;
    if (isEmpty(dataToShow)) {
      _this.goBack();
    } else {
      if ('role' in dataToShow) {
        if (isEmpty(dataToShow.role)) {
          _this.goBack();
        } else {
          dataToShow = dataToShow.role;
        }
      } else {
        _this.goBack();
      }
    }
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <SubViewHeader title='Tambah Role' subTitle='Kelola dashboard yang dapat diakses oleh role ini' />
          <div className="io-container mt-12">
            <IoteraForm
              schema={schema()}
              uiSchema={uiSchema()}
              onSubmit={_this.handleSubmit}
              formData={dataToShow}
            >
              <label style={{ marginBottom: 7 }}>
                <b>Akses Dashboard*</b>
                <InlineTooltip id={'test'} text={'Dashboard yang dipilih akan dapat diakses oleh role ini'} />
              </label>
              <DropdownTreeSelect
                ref={(access) => { _this.access = access; }}
                data={_state.navs}
                placeholderText="Cari..."
                keepTreeOnSearch={true}
                className="dropdown-tree-iotera"
                hierarchical={!_state.descendant}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={_state.descendant}
                    onChange={_this.handleDesc()}
                    color="primary"
                    style={{ padding: 0, margin: '0px 12px' }}
                  />
                }
                label="Include All Children"
              />
              <div className="button-right" style={{ marginTop: 10 }}>
                <button className="button-iotera-white" type="button" style={{ minWidth: '0%' }}
                  onClick={_props.history.goBack} >Kembali</button>
                <button className="button-iotera-primary" type="submit" style={{ marginLeft: 10, minWidth: '0%' }}>Berikutnya</button>
              </div>
            </IoteraForm>
          </div>
        </div>
      </Loader>
    );
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
};

export default connect(null, mapDispatchToProps)(withRouter(RoleAdd));